import React, { useEffect, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import axios from "axios";
import SideBar from "../SideBar";
import { baseUrl } from "../../../baseUrl";
import { useParams } from "react-router-dom";
import {useAuth} from "../../../AuthContext"
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from "react-router-dom";


const EditSubject = () => {
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  const [name, setName] = useState("");
  const params=useParams()

  const [message, setMessage] = useState("");
  const data = { name };
  useEffect(() => {
      const timer = setTimeout(() => {
        setMessage(false);
      }, 4000);
      return () => clearTimeout(timer);
    }, [message]);
  useEffect(()=>{
    axios.get(`${baseUrl}/subject/get?id=${params.id}`)
    .then(res=>{
        setName(res.data.subjectName)
    })
    .catch(err=>console.log(err))
  },[])
  const handleSubmit = (e) => {
    axios
      .post(`${baseUrl}/subject/update?id=${params.id}`, { data })
      .then((res) => {
        if (res.data === "success") {
          setMessage("Subject updated successfully");
        }
        if (res.data === "failed") {
          setMessage("Something went wrong");
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
      <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
      <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
        <nav aria-label="breadcrumb" >
          <ol className="breadcrumb">
            <div className="d-flex flex-grow-1">
              <li className="breadcrumb-item">
                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to='/admin/subjects' className="text-decoration-none">All Subject</Link>
              </li>
              <li className="breadcrumb-item active">
                Edit
              </li>
            </div>
            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                href=""
                role="button"
                aria-expanded="false"
              >
                Welcome, {user.name}
                <i className="ml-2 fa fa-angle-down"></i>
              </span>
              <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                <li>
                  <span className="dropdown-item" onClick={logout}>
                    Logout
                  </span>
                </li>
              </ul>
            </li>
          </ol>
        </nav>
        <div
          className={`container ${styles.container}`}>
          <div className="bg-white p-4">
            <h4>Edit Subject</h4>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="subjectName" className="form-label">
                  Subject Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="subjectName"
                  placeholder="Enter Name"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                />
              </div>
            </div>
            {message && (
              <div
                className="alert alert-warning alert-dismissible fade show mt-3"
                role="alert"
              >
                {message}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                  onClick={() => setMessage(false)}
                ></button>
              </div>
            )}
            <button onClick={handleSubmit} className="btn btn-primary mt-4">
              Update
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default EditSubject;
